<template>
  <section :class="{ 'px-6 py-6': !(!investment.length && noInvestmentsFound) }">
    <no-investments-found-component v-if="!investment.length && noInvestmentsFound" />
    <template v-else>
      <header-investment
        @stop_all="modalStopAll.active = true"
        @filter="active_filter = !active_filter"
        @archived="active_archived = !active_archived"
        :investment="unfilteredInvestments"
      />
      <archived-investment
        :active="active_archived"
        :strategies="unfilteredInvestments.filter((item) => item.status === 'HIDDEN')"
        @close="active_archived = false"
      />
      <filter-investment :active="active_filter" @close="active_filter = false" />

      <section>
        <div v-if="investment.some((item) => item.status == 'RUNNING')" class="flex items-center space-x-3 py-6">
          <div
            @click="expand.running = !expand.running"
            class="text-ontick-steel-400 cursor-pointer"
            :class="expand.running ? 'rotate-180 transform' : 'rotate-0 transform'"
            v-html="icon_arrow"
          ></div>

          <p class="text-ontick-steel-500 w-72 whitespace-nowrap font-medium dark:text-gray-300 md:w-44">
            <span> Em execução </span>
            <span class="text-xs">({{ investment.filter((item) => item.status === "RUNNING").length }})</span>
          </p>
          <hr class="border-ontick-steel-200 dark:border-ontick-steel-500 w-full border" />
          <investments-search-component v-model="searchInput" :loading="fakeLoading" />
          <div class="flex h-10 items-center space-x-3">
            <ontick-toggle-visualization-component
              :value="getVisualizationMode"
              @input="setVisualizationMode($event)"
            />
            <settings-button-component v-if="getVisualizationMode === 'list'" />
          </div>
        </div>
        <collapse-transition>
          <div v-if="expand.running">
            <transition name="fade" mode="out-in">
              <new-list-view-component
                v-if="getVisualizationMode === 'list'"
                :investments="investment.filter((item) => item.status === 'RUNNING')"
                @electronicSignature="openElectronicSignature"
              />
              <card-investment
                v-else
                :loading_strategy="loading_strategy"
                :investment="investment.filter((item) => item.status === 'RUNNING')"
                @electronicSignature="openElectronicSignature"
              ></card-investment>
            </transition>
          </div>
        </collapse-transition>
      </section>
      <section>
        <div v-show="investment.some((item) => item.status == 'STOPPED')" class="flex items-center space-x-3 py-6">
          <div
            @click="expand.stoped = !expand.stoped"
            class="text-ontick-steel-400 cursor-pointer"
            :class="expand.stoped ? 'rotate-180 transform' : 'rotate-0 transform'"
            v-html="icon_arrow"
          ></div>
          <p class="text-ontick-steel-500 w-72 whitespace-nowrap font-medium dark:text-gray-300 md:w-32">
            <span> Parados </span>
            <span class="text-xs">({{ investment.filter((item) => item.status === "STOPPED").length }})</span>
          </p>
          <hr class="border-ontick-steel-200 dark:border-ontick-steel-500 w-full border" />
          <investments-search-component
            v-if="!investment.some((item) => item.status === 'RUNNING')"
            v-model="searchInput"
            :loading="fakeLoading"
          />
          <div class="flex h-10 items-center space-x-3" v-if="!investment.some((item) => item.status === 'RUNNING')">
            <ontick-toggle-visualization-component
              :options="['card', 'list']"
              :value="getVisualizationMode"
              @input="setVisualizationMode($event)"
            />
            <!-- <settings-button-component v-if="getVisualizationMode === 'list'" /> -->
          </div>
        </div>
        <collapse-transition>
          <div v-if="expand.stoped">
            <transition name="fade" mode="out-in">
              <stopped-list-component
                v-if="getVisualizationMode === 'list'"
                :investments="investment.filter((item) => item.status === 'STOPPED')"
                @electronicSignature="openElectronicSignature"
              />
              <card-investment
                v-else
                :loading_strategy="loading_strategy"
                :investment="investment.filter((item) => item.status === 'STOPPED')"
                @electronicSignature="openElectronicSignature"
              ></card-investment>
            </transition>
          </div>
        </collapse-transition>
      </section>
      <section
        v-if="investment.filter((item) => item.status != 'HIDDEN').length == 0"
        class="space-y-32 px-4 sm:px-6 lg:px-8"
      >
        <div class="flex items-center justify-end py-6">
          <investments-search-component v-model="searchInput" :loading="fakeLoading" />
        </div>

        <div class="mx-auto flex h-full max-w-3xl items-center justify-center space-x-6">
          <div class="space-y-6">
            <h1 class="text-ontick-carbon-900 text-2xl font-bold dark:text-gray-300">Nenhum investimento encontrado</h1>
            <p class="text-ontick-carbon-900 dark:text-gray-400">
              Não encontramos nenhum investimento que corresponde aos critérios dos filtros selecionados.
            </p>
          </div>
          <span v-html="filter"></span>
        </div>
      </section>
      <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0  "
        enter-to-class="opacity-100 "
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100"
        leave-to-class="opacity-0 "
      >
        <modal-electronic-signature
          v-if="electronicSignature.isOpen"
          :loadingApi="loading"
          :electronicSignature="electronicSignature"
          :running_success="running_success"
          :init_strategy="init_strategy"
          :investments_ids="investments_ids"
          @close="closeElectronicSignature"
          @confirmCode="confirmCode"
          @initInvestment="updateInvestment"
          @success="loadingSuccess"
          class="overflow-y-scroll"
        ></modal-electronic-signature>
      </transition>
      <!-- /end Modal de assinatura eletrônica -->

      <!-- Parar Tudo - stop todos os investimentos -->
      <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0  "
        enter-to-class="opacity-100 "
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100"
        leave-to-class="opacity-0 "
      >
        <modal-stop-all-investments
          v-if="modalStopAll.active"
          :active="modalStopAll.active"
          @close="closeModalStopAll"
          @stopAll="stopAllInvestments"
        ></modal-stop-all-investments>
      </transition>
    </template>

    <ontick-upgrade-modal-component v-model="upgradeModalData.active" :type="upgradeModalData.type" />

    <ontick-modal-component key="1" :open="startModalInfo.isOpen" size="small" @close="startModalInfo.isOpen = false">
      <start-modal-component :data="startModalInfo" @close="startModalInfo.isOpen = false" />
    </ontick-modal-component>

    <ontick-modal-component key="2" :open="stopModalInfo.isOpen" size="small" @close="stopModalInfo.isOpen = false">
      <stop-modal-component :data="stopModalInfo" @close="stopModalInfo.isOpen = false" />
    </ontick-modal-component>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { CollapseTransition } from "@ivanv/vue-collapse-transition";
import { filter } from "../../../../assets/icons/isometric";
import EventBus from "@/app/shared/utils/event_bus";
import { not_historic } from "../../../../assets/icons/isometric";
import investmentWs from "../../investment-ws.mixin";

export default {
  name: "general",

  mixins: [investmentWs],

  components: {
    CollapseTransition,
    OntickUpgradeModalComponent: () => import("../../../../shared/components/basic/ontick-upgrade-modal.component.vue"),
    StoppedListComponent: () => import("../../components/investment/list-view/stopped/stopped-list.component.vue"),
    SettingsButtonComponent: () => import("../../components/investment/settings-button.component.vue"),
    NoInvestmentsFoundComponent: () => import("../../components/investment/no-investments-found.component.vue"),
    InvestmentsSearchComponent: () => import("../../components/investment/investments-search.component.vue"),
    NewListViewComponent: () => import("../../components/investment/new-list-view/new-list-view.component.vue"),
    CardInvestment: () => import("../../components/investment/card-investment/card-investment.component.vue"),
    ModalElectronicSignature: () =>
      import("../../components/investment/modal-investment/electronic-signature.component.vue"),
    ModalStopAllInvestments: () => import("../../components/investment/modal-investment/modal-stop-all.component.vue"),
    HeaderInvestment: () => import("../../components/investment/header/menu-investment.component.vue"),
    FilterInvestment: () => import("../../components/investment/header/filters-investment.component.vue"),
    ArchivedInvestment: () => import("../../components/investment/header/archived-investment.component.vue"),
    OntickToggleVisualizationComponent: () =>
      import("../../../../shared/components/basic/ontick-toggle-visualization.component.vue"),
    ListViewComponent: () => import("../../components/investment/list-view/running/list-view.component.vue"),

    OntickModalComponent: () => import("../../../../shared/components/basic/ontick-modal.component.vue"),
    StartModalComponent: () => import("../../components/investment/new-investment-modal/start-modal.component.vue"),
    StopModalComponent: () => import("../../components/investment/new-investment-modal/stop-modal.component.vue"),
  },

  data() {
    return {
      filter: filter,
      icon_arrow: `<svg class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M24 24H0V0h24v24z" fill="none" opacity=".87" /> <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z"/> </svg>`,
      typed_volume: 0,
      expand: { running: true, stoped: true },
      loading: false,
      loading_strategy: false,
      active_filter: false,
      active_archived: false,
      investment_selected: {},
      modalStopAll: {
        active: false,
        verificationCode: "",
      },

      electronicSignature: {
        investmentId: 0,
        status: "Zerado",
        isOpen: false,
        loading: false,
      },

      investments_ids: [],
      running_success: false,
      init_strategy: false,
      webSocket: null,
      hasSendMessageInQueue: false,
      not_historic: not_historic,
      upgradeModalData: {
        active: false,
        type: null,
      },
      getPriceInterval: null,
      searchInput: "",
      fakeLoading: false,
      searchTimeout: null,
      noInvestmentsFound: false,
      startModalInfo: {
        isOpen: false,
        investment: null,
        selectedVolume: null,
      },
      stopModalInfo: {
        isOpen: false,
        investment: null,
        selectedVolume: null,
      },
    };
  },

  computed: {
    ...mapState({
      selectedParameter: (state) => state.investment.parameters.selectedParameter,
      selectedParameterInvestment: (state) => state.investment.selectedParameter,
      investmentFilter: (state) => state.investment.adjustments.filters,
    }),
    ...mapGetters({
      unfilteredInvestments: "investment/getInvestments",
      investment: "investment/getFilteredInvestments",
      getVisualizationMode: "investment/getVisualizationMode",
      topics: "investment/getTopics",
      selectedAccount: "accountTypes/getSelectedAccount",
    }),
  },

  methods: {
    ...mapActions({
      getInvestments: "investment/getInvestments",
      checkCode_StartBot: "investment/checkCode_StartBot",
      checkCode_StopBot: "investment/checkCode_StopBot",
      stopAll: "investment/stopAll",
      cleanInvestmentBy: "investment/cleanInvestmentBy",
      cleanAllEvent: "eventAndNotification/cleanAllEvent",
      cleanEventByInvestmentId: "eventAndNotification/cleanEventByInvestmentId",
      incrementNumRunning: "accountTypes/incrementNumRunning",
      decrementNumRunning: "accountTypes/decrementNumRunning",
      setVisualizationMode: "investment/setVisualizationMode",
      startingTopics: "investment/startingTopics",
      stopTopic: "investment/stopTopic",
      updateByInvestmentId: "investment/updateByInvestmentId",
      setInvestmentSymbolPrice: "investment/setInvestmentSymbolPrice",
      setGainLoss: "investment/setGainLoss",
      setStringFilter: "investment/setStringFilter",
    }),

    enter(el, done) {
      TweenMax.fromTo(
        el,
        1,
        {
          autoAlpha: 0,
          scale: 1.5,
        },
        {
          autoAlpha: 1,
          scale: 1,
          transformOrigin: "50% 50%",
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },

    leave(el, done) {
      TweenMax.fromTo(
        el,
        1,
        {
          autoAlpha: 1,
          scale: 1,
        },
        {
          autoAlpha: 0,
          scale: 0.8,
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },

    updateInvestment() {
      // this.getInvestments().then(() => {
      //   this.sendMessage();
      //   this.startingTopics();
      // });
    },

    openElectronicSignature({ investmentId, investmentStatus }) {
      var index = this.investment.findIndex((x) => Number(x.investment_id) == Number(investmentId));
      if (index != -1) {
        if (this.investment[index].status == "RUNNING") {
          // Temporário, depois, não precisará de assinatura eletrônica para start/stop de investimento.
          this.electronicSignature = {
            investmentId,
            status: investmentStatus,
            isOpen: true,
            strategy: this.investment[index],
          };
          // Depois, só vai ser necessário dar start/stop no investimento.
          // this.confirmCode();
        } else {
          this.electronicSignature = {
            investmentId,
            status: investmentStatus,
            isOpen: true,
            strategy: this.investment[index],
          };
        }
      }
    },

    loadingSuccess() {
      this.running_success = true;
      this.updateInvestment();
      setTimeout(() => {
        this.closeElectronicSignature();
      }, 4000);
    },

    closeElectronicSignature() {
      this.electronicSignature.investmentId = 0;
      this.electronicSignature.isOpen = false;
      this.running_success = false;
      this.init_strategy = false;
    },

    async confirmCode(code = "", paramId = null, status = "") {
      // Na conta produção, a assinatura eletrônica é obrigatória.
      if (this.selectedAccount.account_type == "PRD" && status == "RUNNING" && code == "") {
        return;
      }

      if (this.electronicSignature.status == "RUNNING") {
        let params = {
          investment_id: this.electronicSignature.investmentId,
          account_id: this.selectedAccount.account_id,
          type: this.electronicSignature.strategy.type,
        };
        this.stopBot(params);
      } else {
        let params = {
          investment_id: this.electronicSignature.investmentId,
          account_id: this.selectedAccount.account_id,
          typed_volume: this.selectedParameterInvestment.value,
          type: this.electronicSignature.strategy.type,
          volume_type:
            this.investment[
              this.investment.findIndex((item) => item.investment_id === this.electronicSignature.investmentId)
            ]?.volume_type,
        };
        if (
          this.selectedAccount.account_type == "DEMO" ||
          this.selectedAccount.account_type == "CONTEST" ||
          (this.selectedAccount.account_type == "PRD" && code.length == 4)
        ) {
          if (this.electronicSignature.investmentId != 0) {
            if (this.selectedAccount.account_type == "PRD" && code.length == 4) {
              console.log(this.selectedAccount.account_type, code);
              params.user_code = code;
            }
            if (paramId != null) {
              params.param_id = paramId;
            }
            this.startBot(params);
          }
        }
      }
    },

    startBot(params) {
      // console.log("startBot", params);
      // console.trace();

      this.loading = true;
      this.checkCode_StartBot(params)
        .then((response) => {
          this.init_strategy = true;
          this.investments_ids = response.investment_ids;
          this.incrementNumRunning({ account_id: params.account_id });
          if (this.electronicSignature.strategy.type != "PORTFOLIO") {
            this.running_success = true;
            this.updateInvestment();
            setTimeout(() => {
              this.closeElectronicSignature();
            }, 3300);
          }
        })
        .catch((err) => {
          if (!err.modal_action) {
            this.$swal("Erro", err.msg, "error");
            return;
          }
          if (["user_limit_reached", "max_capacity_reached"].includes(err.modal_action)) {
            this.$swal({
              imageUrl: "/img/limit.svg",
              imageAlt:
                err.modal_action === "user_limit_reached"
                  ? "Limite de usuários atingido"
                  : "Volume máximo da estratégia atingido",
              imageWidth: "300px",
              title:
                err.modal_action === "user_limit_reached"
                  ? "Limite de usuários atingido"
                  : "Volume máximo da estratégia atingido",
              text: `A estratégia atingiu o ${
                err.modal_action === "user_limit_reached" ? "limite de usuários" : "volume máximo"
              } estabelecido pelo desenvolvedor`,
            });
            return;
          }
          this.upgradeModalData.type = err.modal_action;
          this.upgradeModalData.active = true;

          EventBus.$emit("CLEAN_ELECTRONIC_SIGNATURE");
        })
        .finally(() => {
          this.loading = false;
          this.getInvestments();
        });
    },

    stopBot(params) {
      this.loading = true;
      this.checkCode_StopBot(params)
        .then((response) => {
          this.electronicSignature.investmentId = 0;
          this.electronicSignature.isOpen = false;
          this.decrementNumRunning({ account_id: params.account_id });
          this.$swal({
            icon: "success",
            iconHtml: this.$icons.swal_success,
            title: response.msg,
            timer: 4000,
          });
          this.getInvestments().then(() => {
            this.startingTopics();
          });
        })
        .catch((error) => {
          this.$swal({
            title: error,
            icon: "error",
            timer: 4000,
          });
          EventBus.$emit("CLEAN_ELECTRONIC_SIGNATURE");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    closeModalStopAll() {
      this.modalStopAll.active = false;
      this.modalStopAll.verificationCode = "";
    },

    stopAllInvestments(accountId) {
      this.loading = true;
      let params = { account_id: accountId };
      try {
        this.stopAll(params)
          .then((response) => {
            this.$swal({
              icon: "success",
              iconHtml: this.$icons.swal_success,
              title: response.msg,
              timer: 4000,
            });
            this.modalStopAll.active = false;
            this.modalStopAll.verificationCode = "";
            this.success_step = false;

            this.getInvestments().then(() => {
              this.cleanAllEvent();
              this.stopTopic();
              this.sendMessage();
            });
          })
          .catch((error) => {
            this.$swal({
              title: error.msg,
              icon: "error",
            });
            this.modalStopAll.active = false;
            this.modalStopAll.verificationCode = "";
          })
          .finally(() => {
            this.loading = false;
          });
      } catch (error) {
        /** error */
      }
    },

    sendMessage() {
      if (this.$route.name == "Investimentos") {
        // Se selectedAccount ainda não estiver definido, então aguarda carregá-lo.

        if (!this.selectedAccount.account_id) {
          this.hasSendMessageInQueue = true;
          return;
        }
        this.$websocket.SendMessage(`${this.selectedAccount.account_id}:${this.selectedAccount.account_number}`);
      }
    },
  },

  watch: {
    searchInput(val) {
      clearTimeout(this.searchTimeout);
      this.fakeLoading = true;
      this.searchTimeout = setTimeout(() => {
        this.setStringFilter({ slug: "chars", value: val });
        this.fakeLoading = false;
      }, 1000);
    },
    selectedAccount(val) {
      // console.log(val);
      // if (this.investment.length == 0) {
      this.getInvestments({
        uuid: this.contextUuid,
        type: "Investments page",
        accountChange: true,
      })
        // .then(() => {
        //   this.sendMessage();
        //   this.startingTopics();
        // })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading_strategy = false;
        });
      // }
    },
    investment(val) {
      if (val.filter((item) => item.strategy_market === "Equities" && item.status === "RUNNING").length) {
        clearInterval(this.getPriceInterval);
        this.getPriceInterval = setInterval(() => {
          this.setGainLoss({ running_only: true }).catch(() => {});
        }, 20000);
      } else {
        clearInterval(this.getPriceInterval);
      }
    },
  },

  created() {
    EventBus.$on("CLOSE_INVESTMENT_FILTERS", () => {
      this.active_filter = false;
    });
    EventBus.$on("START_INVESTMENT_MODAL", ({ investmentInfo, selectedVolume }) => {
      this.startModalInfo.investment = investmentInfo;
      this.startModalInfo.selectedVolume = selectedVolume;
      this.startModalInfo.isOpen = true;
    });
    EventBus.$on("STOP_INVESTMENT_MODAL", ({ investmentInfo }) => {
      this.stopModalInfo.investment = investmentInfo;
      this.stopModalInfo.isOpen = true;
    });
    this.loading_strategy = true;
    if (Object.keys(this.selectedAccount).length > 0) {
      this.getInvestments()
        .then((res) => {
          // console.log(res);
          this.noInvestmentsFound = false;
        })
        .catch(({ data }) => {
          if (data.msg === "Nenhum investimento encontrado para o usuário") {
            this.noInvestmentsFound = true;
          }
        })
        .finally(() => {
          this.loading_strategy = false;
        });
    }
  },
};
</script>
<style lang="scss" scoped>
.fade {
  &-enter-active,
  &-leave-active {
    @apply transition-all duration-500 ease-in-out;
  }
  &-enter, &-leave-to /* .fade-leave-active below version 2.1.8 */ {
    @apply opacity-0;
  }
}
</style>
